import { utils } from 'gipsy-misc'

export const groupTeamItems = output => {
  const withoutUpdateETATasks = output.withoutUpdateETATasks || []
  const groupedItems = utils.datetime.groupItemsByDate(withoutUpdateETATasks, ['ETA.time', 'ETA.date'])

  const withUpdateETATasks = output.withUpdateETATasks || []
  groupedItems.updates = {
    list: withUpdateETATasks
  }

  return groupedItems
}

export const getAssigneeFromWatchedTasksOutput = output => {
  if (output.withUpdateETATasks && output.withUpdateETATasks.length > 0) {
    return output.withUpdateETATasks[0].to
  } else if (output.withoutUpdateETATasks && output.withoutUpdateETATasks.length > 0) {
    return output.withoutUpdateETATasks[0].to
  }
  return null
}



// WEBPACK FOOTER //
// ./src/features/teamlist/utils.js